import { Translations } from '~/app/i18n/i18n';

export const cleanTranslations = (translations: Translations) => {
	return Object.fromEntries(Object.entries(translations).map(([key, value]) => [key?.trim(), value?.trim()]));
};
